<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.md_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="md_prodcode">
            <label class="weui-form-preview__label">{{customLabel.md_prodcode || "物料编号"}}</label>
            <em class="weui-form-preview__value">{{form.main.md_prodcode}}</em>
          </div>
          <div class="weui-form-preview__item" slot="md_proddetail">
            <label class="weui-form-preview__label">{{customLabel.md_proddetail || "物料名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.md_proddetail}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_orispeccode" v-if="form.main.pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_spec" v-if="form.main.pr_spec">
            <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_brand" v-if="form.main.pr_brand">
            <label class="weui-form-preview__label">{{customLabel.pr_brand || "厂家/品牌"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_type">
            <label class="weui-form-preview__label">{{customLabel.md_type || "制造类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.md_type}}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_qty">
            <label class="weui-form-preview__label">{{customLabel.md_qty || "数量"}}</label>
            <span class="weui-form-preview__value">{{form.main.md_qty}} {{ form.main.pr_unit }}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_qty_extra" v-if="form.main.md_qty_extra">
            <label class="weui-form-preview__label">{{customLabel.md_qty_extra || "辅助数量"}}</label>
            <span class="weui-form-preview__value">{{form.main.md_qty_extra}} {{ form.main.pr_unit_extra }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_length">
            <label class="weui-form-preview__label">{{customLabel.pr_length || "长"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_length}} cm</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_width">
            <label class="weui-form-preview__label">{{customLabel.pr_width || "宽"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_width}} cm</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_height">
            <label class="weui-form-preview__label">{{customLabel.pr_height || "厚"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_height}} cm</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_weight">
            <label class="weui-form-preview__label">{{customLabel.pr_weight || "重"}}</label>
            <span class="weui-form-preview__value">{{form.main.pr_weight}} kg</span>
          </div>
          <div class="weui-form-preview__item" slot="md_moldcode">
            <label class="weui-form-preview__label">{{customLabel.md_moldcode || "模具编号"}}</label>
            <span class="weui-form-preview__value">{{form.main.md_moldcode}}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_lossrate">
            <label class="weui-form-preview__label">{{customLabel.md_lossrate || "损耗率"}}</label>
            <span class="weui-form-preview__value">{{form.main.md_lossrate}}%</span>
          </div>
          <div class="weui-form-preview__item" slot="md_offcut">
            <label class="weui-form-preview__label">{{customLabel.md_offcut || "边角料"}}</label>
            <span class="weui-form-preview__value">{{form.main.md_offcut}}%</span>
          </div>
          <div class="weui-form-preview__item" slot="md_thisqty">
            <label class="weui-form-preview__label">{{customLabel.md_thisqty || "已领数"}}</label>
            <span class="weui-form-preview__value">{{form.main.md_thisqty}}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_turngetqty">
            <label class="weui-form-preview__label">{{customLabel.md_turngetqty || "转领料数"}}</label>
            <span class="weui-form-preview__value">{{form.main.md_turngetqty}}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_turnbackqty">
            <label class="weui-form-preview__label">{{customLabel.md_turnbackqty || "转退料数"}}</label>
            <span class="weui-form-preview__value">{{form.main.md_turnbackqty}}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_planbegindate">
            <label class="weui-form-preview__label">{{customLabel.md_planbegindate || "开工日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.md_planbegindate}}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_planenddate">
            <label class="weui-form-preview__label">{{customLabel.md_planenddate || "完工日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.md_planenddate}}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_wcname">
            <label class="weui-form-preview__label">{{customLabel.md_wcname || "工作中心"}}</label>
            <span class="weui-form-preview__value">{{form.main.md_wcname}}</span>
          </div>
        </custom-layout>
      </div>

      <collapse class="form-preview weui-form-preview" :title="'明细（'+form.items.length+'条）'">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.dd_detno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="dd_prodcode">
              <label class="weui-form-preview__label">{{customLabel.dd_prodcode || "产品"}}</label>
              <span
                class="weui-form-preview__value"
              >{{item.dd_prodcode}} {{item.pr_detail}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.pr_brand" slot="pr_brand">
              <label class="weui-form-preview__label">{{customLabel.pr_brand || "品牌"}}</label>
              <span class="weui-form-preview__value">{{item.pr_brand}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.pr_orispeccode" slot="pr_orispeccode">
              <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">{{item.pr_orispeccode}}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.pr_spec" slot="pr_spec">
              <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
              <span class="weui-form-preview__value">{{item.pr_spec}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_length">
              <label class="weui-form-preview__label">{{customLabel.pr_length || "长"}}</label>
              <span class="weui-form-preview__value">{{item.pr_length}} cm</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_width">
              <label class="weui-form-preview__label">{{customLabel.pr_width || "宽"}}</label>
              <span class="weui-form-preview__value">{{item.pr_width}} cm</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_height">
              <label class="weui-form-preview__label">{{customLabel.pr_height || "厚"}}</label>
              <span class="weui-form-preview__value">{{item.pr_height}} cm</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_weight">
              <label class="weui-form-preview__label">{{customLabel.pr_weight || "重"}}</label>
              <span class="weui-form-preview__value">{{item.pr_weight}} kg</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_oneuseqty">
              <label class="weui-form-preview__label">{{customLabel.dd_oneuseqty || "单位用量"}}</label>
              <span class="weui-form-preview__value">{{item.dd_oneuseqty}} {{item.pr_unit}}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_qty">
              <label class="weui-form-preview__label">{{customLabel.dd_qty || "分切数量"}}</label>
              <span class="weui-form-preview__value">{{item.dd_qty}}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_turnqty">
              <label class="weui-form-preview__label">{{customLabel.dd_turnqty || "已转入库数"}}</label>
              <span class="weui-form-preview__value">{{item.dd_turnqty}}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_inqty">
              <label class="weui-form-preview__label">{{customLabel.dd_inqty || "完工数"}}</label>
              <span class="weui-form-preview__value">{{item.dd_inqty}}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_turnscrapqty">
              <label class="weui-form-preview__label">{{customLabel.dd_turnscrapqty || "转报废数"}}</label>
              <span class="weui-form-preview__value">{{item.dd_turnscrapqty}}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_scrapqty">
              <label class="weui-form-preview__label">{{customLabel.dd_scrapqty || "报废数"}}</label>
              <span class="weui-form-preview__value">{{item.dd_scrapqty}}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_costrate">
              <label class="weui-form-preview__label">{{customLabel.dd_costrate || "材料成本比例"}}</label>
              <span class="weui-form-preview__value">{{item.dd_costrate}}%</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_batchcode">
              <label class="weui-form-preview__label">{{customLabel.dd_batchcode || "批次号"}}</label>
              <span class="weui-form-preview__value">{{item.dd_batchcode}}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_madetime">
              <label class="weui-form-preview__label">{{customLabel.dd_madetime || "生产日期"}}</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.dd_madetime}}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_shelflife">
              <label class="weui-form-preview__label">{{customLabel.dd_shelflife || "保质期"}}</label>
              <span class="weui-form-preview__value">{{item.dd_shelflife}} 天</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_lifedate">
              <label class="weui-form-preview__label">{{customLabel.dd_lifedate || "保质期"}}</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.dd_lifedate}}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_remark">
              <label class="weui-form-preview__label">{{customLabel.dd_remark || "备注"}}</label>
              <span class="weui-form-preview__value">{{item.dd_remark}}</span>
            </div>
          </custom-layout>
        </div>
      </collapse>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{form.main.md_remark}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">领料状态</label>
            <span class="weui-form-preview__value">{{form.main.md_getstatus}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">完工状态</label>
            <span class="weui-form-preview__value">{{form.main.md_finishstatus}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import Collapse from "@/components/Collapse.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    Collapse
  },
  data() {
    return {
      baseUrl: "/api/make/makeDisassemble",
      caller: "MakeCut",
      xtype: "make-makecut-formpanel",
    };
  }
};
</script>